import { SkuGroups } from "./History";
import { GroundPositionType } from './GroundPosition';

export interface PigeonholeGroup {
  id: string;
  tenantId: string;
  name: string;
  type: GroundPositionType;
  createdAt: number;
  updatedAt: number;
}

export enum PigeonholeType {
  EXIT = 'EXIT',
  EXPEDITION = 'EXPEDITION',
  PICKING = 'PICKING',
  PICKING_MISCELLANEOUS = "PICKING_MISCELLANEOUS",
  STOCK = 'STOCK',
}

export interface PigeonholePositionInfo {
  id: string;
  rfid: string;
  state: string;
  tenantId: string;
  type: string;
  x: number;
  y: number;
  z: number;
  reference: number;
  levelType: string;
  createdAt: number;
  updatedAt: number;
  alias: string | null;
  groundPositionGroupId: string | null;
  levelStart: number | null;
  levelEnd: number | null;
  levelName: string | null;
  group?: PigeonholeGroup;
}

export interface PigeonholeMapPosition {
  id: string;
  hasPallet: boolean;
  columnMapLabel: string;
  rowMapLabel: string;
  qrCode: string;
  state: string;
  type: GroundPositionType;
  column: number;
  row: number;
  alias: string | null;
}

export interface PigeonholePackage {
  id: string;
  x: number;
  y: number;
  z: number;
  skuGroups: SkuGroups[];
  pigeonholeId: string;
}

export interface PigeonholeOccupationInfo {
  totalPigeonholes: number;
  totalOccupiedPigeonholes: number;
  totalFreePigeonholes: number;
}

export interface PigeonholePackageDetail {
  id: string;
  lastMovedAt: number;
  state: string;
  tagRfid: string;
  x: number;
  y: number;
  z: number;
  type: string;
  position: string;
  tenantId: string;
  createdAt: number;
  updatedAt: number;
  skuGroups: SkuGroups[];
}

export interface PigeonholeDetails {
  id: string;
  tenantId: string;
  groundPositionId: string;
  qrCode: string;
  row: number;
  column: number;
  type: string;
  state: string;
  createdAt: number;
  updatedAt: number;
  alias?: string;
  coords?: string;
}

export interface PigeonholeDetailsResponse {
  packages: PigeonholePackageDetail[];
  pigeonhole: PigeonholeDetails;
}

export interface PigeonholeMisplacedPallets {
  id: string;
  lastMovedAt: number;
  state: string;
  tagRfid?: string;
  x: number;
  y: number;
  z: number;
  type: string;
  position?: string;
  tenantId?: string;
  createdAt: number;
  updatedAt: number;
  skuGroups: SkuGroups[];
}
export interface PigeonholeRowColumnResponseItem {
  pigeonhole: PigeonholeDetails;
  packages: PigeonholePackageDetail[];
}

export type PigeonholeRowColumnResponse = PigeonholeRowColumnResponseItem[];
